import { render, staticRenderFns } from "./BillingView.vue?vue&type=template&id=5c72b528&scoped=true"
import script from "./BillingView.vue?vue&type=script&lang=js"
export * from "./BillingView.vue?vue&type=script&lang=js"
import style0 from "./BillingView.vue?vue&type=style&index=0&id=5c72b528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c72b528",
  null
  
)

export default component.exports